module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-上传-图片.a9212.png";